import { useActiveKeysStore } from './store'

export { useActiveKeysStore }
export type { ActiveKeyItem } from './types'

export function useActiveKeys() {
  return useActiveKeysStore()
}
